import { DateTime } from "luxon";
import { IWorkItemScope, WorkItemController } from "../workItemController";

export class WorkItemTypeDateController extends WorkItemController {
  datepickerOptions: angular.ui.bootstrap.IDatepickerConfig = {};

  datepickerOpened: boolean = false;

  openDatepicker($event: angular.IAngularEvent) {
    $event.preventDefault();
    $event.stopPropagation?.();
    this.datepickerOpened = true;
  }
}
